import React from "react";
import { ServiceSection, ServiceCard } from "@/.storyblok/types/319751/storyblok-components";
import Link from "next/link";
import Image from "next/image";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface ServiceSectionProps {
  blok?: ServiceSection & SbBlokData;
}

const ServiceSectionComponent: React.FC<ServiceSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { section_title, bg_style, services } = blok;

  const rowClassName =
    services && services.length === 3
      ? "row row-cols-1 row-cols-lg-3 g-4"
      : "row row-cols-1 row-cols-lg-2 g-4";


  return (
    <>
      {(bg_style as string) === "dark" ? (
        <div {...storyblokEditable(blok)} className="bg-light">
          <div className="container">
            <section className="py-4 py-md-5">
              {section_title && (
                <h2 className="text-primary text-center mb-5">
                  {section_title}
                </h2>
              )}

              <div className={rowClassName}>
                {services?.map((service: ServiceCard) => {
                  const {
                    title,
                    subtitle,
                    description,
                    icon,
                    link,
                    button_text,
                    _uid,
                  } = service;

                  return (
                    <div className="col" key={_uid}>
                      <Link
                        href={link?.url || "#"}
                        className="card-penetration-testing card card-lighter h-100"
                        target={
                          (link?.linktype as string) === "external"
                            ? "_blank"
                            : "_self"
                        }
                        rel={
                          (link?.linktype as string)
                            ? "noopener noreferrer"
                            : undefined
                        }
                      >
                        <div className="card-body p-2 p-md-3 p-lg-4 h-100">
                          <div className="panel-text text-center h-100 d-flex align-items-center flex-column">
                            {icon?.filename && (
                              <div className="svg icon-circled mb-4">
                                <Image
                                  src={icon.filename}
                                  width={100}
                                  height={100}
                                  alt={icon.alt || title || ""}
                                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                  loading="lazy"
                                  quality={75}
                                />
                              </div>
                            )}

                            {title && (
                              <h3 className="text-primary mb-lg-2">{title}</h3>
                            )}

                            {subtitle && (
                              <p className="lead fw-bolder mb-3 text-secondary">
                                {subtitle}
                              </p>
                            )}

                            {description && (
                              <p className="mb-4">{description}</p>
                            )}

                            {button_text && (
                              <span className="btn btn-secondary mt-auto">
                                {button_text}
                              </span>
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </section>
          </div>
        </div>
      ) : (
        <div {...storyblokEditable(blok)} className="container">
          <section className="py-4 py-md-5">
            {section_title && (
              <h2 className="text-primary text-center mb-5">{section_title}</h2>
            )}

            <div className={rowClassName}>
              {services?.map((service: ServiceCard) => {
                const {
                  title,
                  subtitle,
                  description,
                  icon,
                  link,
                  button_text,
                  _uid,
                } = service;

                return (
                  <div className="col" key={_uid}>
                    <Link
                      href={link?.url || "#"}
                      className="card-penetration-testing card card-lighter h-100"
                      target={
                        (link?.linktype as string) === "external"
                          ? "_blank"
                          : "_self"
                      }
                      rel={
                        (link?.linktype as string)
                          ? "noopener noreferrer"
                          : undefined
                      }
                    >
                      <div className="card-body p-2 p-md-3 p-lg-4 h-100">
                        <div className="panel-text text-center h-100 d-flex align-items-center flex-column">
                          {icon?.filename && (
                            <div className="svg icon-circled mb-4">
                              <Image
                                src={icon.filename}
                                width={100}
                                height={100}
                                alt={icon.alt || title || ""}
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                loading="lazy"
                                quality={75}
                              />
                            </div>
                          )}

                          {title && (
                            <h3 className="text-primary mb-lg-2">{title}</h3>
                          )}

                          {subtitle && (
                            <p className="lead fw-bolder mb-3 text-secondary">
                              {subtitle}
                            </p>
                          )}

                          {description && <p className="mb-4">{description}</p>}

                          {button_text && (
                            <span className="btn btn-secondary mt-auto">
                              {button_text}
                            </span>
                          )}
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      )}
      <hr />
    </>
  );
};

export default ServiceSectionComponent;